import type { StyleElements } from "replo-runtime/shared/utils/styles";
import type { CustomPropsRecord } from "schemas/component";
import type { ComponentConfig } from "../../components";

import { convertToLegacyProps } from "../../../shared/utils/props";

function getConfigurableProps(): CustomPropsRecord {
  return {
    url: {
      type: "url",
      name: "TikTok URL",
      description: "URL of the TikTok post to embed.",
      defaultValue: "",
    },
  };
}

export const customProperties = {
  display: "--rdi",
};

const styleElements = {
  root: {},
  inner: {
    defaultStyles: {
      display: `var(${customProperties.display}, none)`,
      minWidth: "390px",
      width: "100%",
      height: "auto",
    },
  },
} as const satisfies StyleElements;

const config = {
  renderData: {
    customProps: convertToLegacyProps(getConfigurableProps()),
    newInstancesUseNumbering: true,
    acceptsArbitraryChildren: () => false,
    isAlwaysDynamic: false,
    canvasIndicatorDragDirections: [],
    allowsLayoutModification: false,
    canContainChildren: false,
    styleElements,
  },
} satisfies ComponentConfig;

export default config;
